<script setup>
import { getSrcSet } from '@helpers/utils'
const props = defineProps(['src', 'alt', 'sizes'])
const srcSet = getSrcSet(props.src)
</script>

<template>
  <img
      :src="src.url"
      :srcset="srcSet"
      :sizes="srcSet ? sizes : null"
      :alt="alt"
      :width="src.width"
      :height="src.height"
  />
</template>
